import { render, staticRenderFns } from "./RelatorioTable.vue?vue&type=template&id=7a83ac38&scoped=true&"
import script from "./RelatorioTable.vue?vue&type=script&lang=js&"
export * from "./RelatorioTable.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioTable.vue?vue&type=style&index=0&id=7a83ac38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83ac38",
  null
  
)

export default component.exports